import React from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { useTranslation } from 'react-i18next';
import './Calendar.css';

const EVENT_TYPE_LABELS = {
  lesson: 'College',
  college: 'College',
  event: 'Evenement',
  exam: 'Tentamen',
  resit: 'Hertentamen',
  'bp-submission': 'Inleveren Beroepsproduct',
  'so-submission': 'Inleveren Schriftelijke opdracht',
  'adviesrapport-submission': 'Inleveren Adviesrapport',
  'bp-so-submission': 'Inleveren BP/SO',
  presentation: 'Presentatie',
  'report-submission': 'Verslag indiening',
  'report-review': 'Verslag bespreking',
  activity: 'Activiteit'
};

const CALENDAR_TIME_ZONE = 'America/Paramaribo';

const formatTime = (value) => {
  if (!value) return '';
  return new Date(value).toLocaleTimeString('nl-NL', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: CALENDAR_TIME_ZONE
  });
};

const Calendar = ({ events = [], onEventClick, onDateClick, editable = false, headerToolbar }) => {
  const { t } = useTranslation();

  const defaultHeaderToolbar = {
    left: 'prev,next today',
    center: 'title',
    right: 'dayGridMonth,timeGridWeek,timeGridDay',
    ...headerToolbar
  };

  const renderEventContent = (eventInfo) => {
    const event = eventInfo.event;
    const start = formatTime(event.start);
    const end = formatTime(event.end);
    const timeRange = start && end ? `${start} - ${end}` : start || end || '';
    const title = event.title || '';

    return (
      <div className="calendar-event-content">
        <div className="calendar-event-title">{title}</div>
        <div className="calendar-event-meta">{timeRange}</div>
      </div>
    );
  };

  const getEventClassNames = (arg) => {
    const type = arg.event.extendedProps?.eventType || arg.event.extendedProps?.type || 'college';
    return [`calendar-event`, `calendar-event-${type}`];
  };

  return (
    <div className="calendar-container">
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        timeZone={CALENDAR_TIME_ZONE}
        headerToolbar={defaultHeaderToolbar}
        events={events}
        eventClick={onEventClick}
        dateClick={onDateClick}
        editable={editable}
        selectable={editable}
        selectMirror={true}
        dayMaxEvents={false}
        dayMaxEventRows={false}
        locale="nl"
        firstDay={1}
        buttonText={{
          today: t('calendar.today'),
          month: t('calendar.month'),
          week: t('calendar.week'),
          day: t('calendar.day'),
          prev: '❮',
          next: '❯'
        }}
        eventTimeFormat={{
          hour: '2-digit',
          minute: '2-digit',
          meridiem: false
        }}
        eventContent={renderEventContent}
        eventClassNames={getEventClassNames}
      />
    </div>
  );
};

export default Calendar;
